<template>
  <div class="tg-login">
    <div class="tg-login--container authVerify">
      <h1 class="tg-login--title">{{ title }}</h1>
      <div :class="formClass">
        <el-row type="flex" align="middle ma-t-4">
          <div class="col-3 text-align-center column">
            {{ $t("column.input_username") }}
          </div>
          <div class="col-9">
            <el-input
              v-model="formData.username"
              class="tg-input"
              :class="{ hasError: hasError && !formData.username }"
              :placeholder="$t('column.input_username_placeholder')"
            ></el-input>
          </div>
        </el-row>
        <el-row type="flex" align="middle" class="ma-t-4">
          <div class="col-3 text-align-center column">
            {{ $t("column.cellphone") }}
          </div>
          <el-row
            class="col-9"
            type="flex"
            align="middle"
            justify="space-between"
          >
            <tg-dropdown
              :items="areaDropdown"
              class="col-9 area-dropdown"
              :class="{ hasError: hasError && !formData.area }"
              @on-change="handleAreaChange"
              trigger="click"
              placement="bottom-end"
              menuClass="cellphone-area"
              :autoWidth="false"
              :width="118"
            ></tg-dropdown>
            <el-input
              v-model="formData.cellphone"
              class="tg-input"
              :class="{ hasError: hasError && !formData.cellphone }"
              type="number"
              :placeholder="$t('component.form.input.placeholder.cellphone')"
            ></el-input>
          </el-row>
        </el-row>
        <el-row type="flex" align="middle" class="ma-t-4">
          <div class="col-3 text-align-center column">
            {{ $t("column.graphicValidation") }}
          </div>
          <el-row
            class="col-9"
            type="flex"
            align="middle"
            justify="space-between"
          >
            <el-input
              v-model="formData.patternCode"
              :class="{ hasError: hasError && !formData.patternCode }"
              class="tg-input col-5"
              :placeholder="
                $t('component.form.input.placeholder.graphicValidation')
              "
            ></el-input>
            <div class="input-group">
              <div class="input-group-addon clickable" @click="getGraphicImage">
                <i class="tg-icon tg-icon-update"></i>
              </div>
              <div class="input-control">
                <img :src="graphicImage" width="100%" height="100%" />
              </div>
            </div>
          </el-row>
        </el-row>
        <el-row type="flex" align="middle" class="ma-t-4">
          <div class="col-3 text-align-center column">{{ $t("column.sms") }}</div>
          <el-row
            class="col-9"
            type="flex"
            align="middle"
            justify="space-between"
          >
            <el-input
              v-model="formData.sms"
              :class="{ hasError: hasError && !formData.sms }"
              class="tg-input col-7"
              maxlength="4"
              :placeholder="$t('component.form.input.placeholder.sms')"
            ></el-input>
            <tg-button
              fill
              theme="warning"
              round
              class="col-5"
              style="height: 40px"
              @click.native="handleSendSMS"
              :disabled="nextSendSMS > 0"
              >{{ sendSMSLabel }}</tg-button
            >
          </el-row>
        </el-row>
        <el-row type="flex" justify="end" align="middle" class="ma-t-4">
          <tg-button
            round
            class="tg-btn-prompt--next col-9"
            :class="{ active }"
            @click.native="handleSubmit"
            >{{ $t("component.btn.next") }}</tg-button
          >
        </el-row>
      </div>
      <!-- 錯誤彈窗 -->
      <el-alert
        type="tg-alert"
        show-icon
        v-show="alert.show"
        :style="alert.style"
        ref="alert"
        tabindex="-1"
        style="outline: none"
        @blur.native="handleAlertClose"
        @close="handleAlertClose"
        >{{ alert.message }}</el-alert
      >
      <tg-dialog
        showIcon
        showFooter
        top="35vh"
        width="20%"
        :theme="alert.type"
        :visible.sync="showDialog"
        :subject="alert.subject"
        :subtitle="alert.subtitle"
        :confirmLabel="alert.type == 'info' ? $t('component.btn.finish') : null"
        @on-confirm="handleFinish"
      ></tg-dialog>
    </div>
  </div>
</template>

<script>
import TgDropdown from "@/components/dropdown/TgDropdown";
import TgButton from "@/components/button/TgButton";
import TgDialog from "@/components/dialog/TgDialog";

import apis from "@/apis";

let _tg_interval = null;

export default {
  components: {
    TgDropdown,
    TgButton,
    TgDialog,
  },
  data() {
    return {
      formData: {
        username: "",
        cellphone: "",
        patternCode: "",
        area: "",
        sms: "",
      },
      areaDropdown: [],
      alert: {
        type: "warning",
        subject: "",
        subtitle: "",
      },
      nextSendSMS: 0,
      sec: "",
      graphicImage: "",
      showDialog: false,
      hasError: false,
    };
  },
  props: {
    isForgetPwd: Boolean,
  },
  computed: {
    title() {
      return this.$t("page.other." + this.$route.name + ".title");
    },
    formClass() {
      return ["tg-login--form", "cellphone-validate", this.$route.name];
    },
    sendSMSLabel() {
      return this.$t("component.btn.sendSMS") + this.sec;
    },
    smsRequest() {
      return {
        phone: this.formData.cellphone,
        area: this.formData.area,
        targetName: this.formData.username,
      };
    },
    active() {
      return (
        !!this.formData.cellphone &&
        !!this.formData.area &&
        !!this.formData.username &&
        !!this.formData.patternCode &&
        !!this.formData.sms
      );
    },
    subject() {
      return this.$t("message.success.unlock.title");
    },
    subtitle() {
      return this.$t("message.success.unlock.note");
    },
  },
  created() {
    apis.dropdown.getCountryCode().then((response) => {
      let areaCode = response.data.map(x => {
          x.label = this.$t(x.langKey);
          return x;
        });
      this.areaDropdown = [
        {
          label: this.$t("component.dropdown.areaCode"),
          value: "",
        },
        ...areaCode,
      ];
      this.getGraphicImage();
    });
  },
  methods: {
    handleAreaChange(item) {
      this.formData.area = item.value;
    },
    handleAlertClose() {
      this.showDialog = false;
    },
    setIntervalSMS() {
      this.nextSendSMS -= 1;
      this.sec = this.nextSendSMS > 0 ? "(" + this.nextSendSMS + ")" : "";

      if (this.nextSendSMS <= 0) {
        clearInterval(_tg_interval);
      }
    },
    lockSendSMSBtn(sec) {
      this.nextSendSMS = sec;
      this.sec = sec > 0 ? "(" + sec + ")" : "";
      _tg_interval = setInterval(this.setIntervalSMS, 1000);
    },
    showALert(type, subject, subtitle = "", options = {}) {
      this.alert = { ...this.alert, type, ...options, subject, subtitle };
      this.$nextTick(() => {
        // this.$refs.alert.$el.focus();
        this.showDialog = true;
      });
    },
    handleSendSMS() {
      if (!this.formData.cellphone || !this.formData.area) {
        this.showALert("warning", this.$t("message.error.required.cellphone"));
        return;
      }

      apis.sms.sendSMS(this.smsRequest).then(({ retcode, data, message }) => {
        if (retcode == 1) {
          this.lockSendSMSBtn(data.sec);
          this.showALert("warning", this.$t("enum.sms.statusCode["+message+"]"));
        } else {
          this.lockSendSMSBtn(180);
          this.$message.success(this.$t("message.success.sms") + (data.code ? ' 【' + data.code + '】' : ''));
        }
      });
    },
    checkActive() {
      this.$nextTick(() => {
        let fields = ["username", "cellphone", "patternCode", "sms"];
        let pass = true;
        fields.forEach((field) => {
          if (!this.formData[field]) {
            pass = false;
          }
        });
        this.active = pass;
      });
    },
    getGraphicImage() {
      apis.getVerificationImage().then((response) => {
        if(response.retcode == 0){
          this.graphicImage = response.data.image;
          this.formData.rdcode = response.data.rdcode;
          this.formData.patternCode = "";
        }
      });
    },
    handleSubmit() {
      this.hasError = !this.active;
      if (!this.active) {
        this.showALert("warning", this.$t("message.error.required.form"));
        return;
      }

      apis.validateCellphone(this.formData).then((response) => {
        if (response.retcode !== 0) {
          this.showALert("warning", this.$t("statusCode["+response.retcode+"]"));
        } else {
          // 忘記密碼 > 重設密碼
          if (this.isForgetPwd) {
            this.$router.push({ name: "changePwd" });
          } else {
            // 申請解鎖
            apis.member.action
              .unlock({ username: this.formData.username })
              .then((response) => {
                if (response.retcode == 0) {
                  this.showALert(
                    "info",
                    this.$t("message.success.unlock.title"),
                    this.$t("message.success.unlock.note")
                  );
                } else {
                  this.showALert("warning", this.$t("statusCode["+response.retcode+"]"));
                }
              });
          }
        }
      });
    },
    handleFinish() {
      if (this.alert.type == "info") {
        this.$router.push({ name: "login" });
      }
    },
  },
  watch: {
    "$route.name"() {
      this.formData = {
        username: "",
        cellphone: "",
        patternCode: "",
        area: "",
        sms: "",
      };
    },
  },
};
</script>
